import moment from 'moment'

export function formatEventListTime({
  start_date: startDate,
  start_date_exact: startDateExact,
  end_date: endDate,
  time_info: timeInfo,
}) {
  const difference = moment(startDate).diff(moment(endDate), 'days', true)

  if (difference === 0) {
    const date = moment(startDate).format('DD.MM.YYYY')

    if (timeInfo) {
      return `${date} ${timeInfo}`
    }

    return moment(startDateExact).format('DD.MM.YYYY HH:mm')
  }

  return `${moment(startDate).format('DD.MM.YYYY')} – ${moment(
    endDate
  ).format('DD.MM.YYYY')}`
}

/** last_sales_date arrives as a corrected ISO instant (Helsinki wall-clock). */
export function formatLastSalesDate(lastSalesDate) {
  if (!lastSalesDate) {
    return ''
  }

  return moment(lastSalesDate).format('DD.MM.YYYY [klo] HH')
}
